import { ContentService } from '@blk/cwp-ng-framework';
import { DateUtil } from '@ddt-web/generic-utils';

import { Formatter } from './formatter.interface';

export class BFMDateFormatter implements Formatter {
	public static readonly FULL: Intl.DateTimeFormatOptions = { timeZone: 'UTC', year: 'numeric', month: 'numeric', day: 'numeric' };
	public static readonly SHORT: Intl.DateTimeFormatOptions = { timeZone: 'UTC', year: '2-digit', month: 'numeric', day: 'numeric' };

	constructor(private options: Intl.DateTimeFormatOptions = BFMDateFormatter.FULL) { }
	public format(value: any, contentSvc?: ContentService): string {
		return value && typeof value === 'number'
			? DateUtil.convertBfmDate(value).toLocaleDateString('en-US', this.options).replace(/\u200E/g, '')
			: value;
	}
}
